// extracted by mini-css-extract-plugin
export default {"page":"NotFound_page__CAy8u","actions":"NotFound_actions__lUson"};